import { useTranslate } from "@similarweb/i18n-provider";
import { Alerts } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { ScrapingIconWrapper } from "app/pages/activation/components/HomeWithData/ShareData/TrafficWidgets/RankTracker/BodyByState/styles";
import { EMPTY_SCRAPING_MESSAGE } from "app/pages/activation/components/HomeWithData/ShareData/TrafficWidgets/RankTracker/texts";

export const Scraping = () => {
    const { translate } = useTranslate();

    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            gap="8px"
        >
            <ScrapingIconWrapper>
                <Alerts color={colorsPalettes.carbon[0]} />
            </ScrapingIconWrapper>

            <Text
                fontVariant="body2"
                maxWidth="290px"
                textAlign="center"
            >
                {translate(EMPTY_SCRAPING_MESSAGE)}
            </Text>
        </Stack>
    );
};
